module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "layout-navigation"
    }
  }, [_c('nav', {
    attrs: {
      "id": "navigation"
    }
  }, [_c('section', {
    attrs: {
      "id": "selections"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "list"
    }
  }, [_c('Library', {
    attrs: {
      "objectTypes": ['stories'],
      "mode": 'stories',
      "compact": _vm.libraryExpanded !== 'stories'
    },
    on: {
      "toggleCompact": function($event) {
        _vm.libraryExpanded = (_vm.libraryExpanded === 'stories' ? false : 'stories')
      }
    }
  }), _vm._v(" "), _c('Library', {
    attrs: {
      "addNewOnHotkey": "true",
      "objectTypes": _vm.objectTypesForTab,
      "mode": _vm.subselectionType,
      "searchAvailable": true,
      "compact": _vm.libraryExpanded !== 'subselection'
    },
    on: {
      "changeMode": function (newMode) {
        _vm.subselectionType = newMode;
      },
      "toggleCompact": function($event) {
        _vm.libraryExpanded = (_vm.libraryExpanded === 'subselection' ? false : 'subselection')
      }
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64bc751c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 752
// module chunks = 2